(async () => {
    await new Promise(
        (resolve) => {
            const interval = setInterval(
                () => {
                    if (typeof creodeShopifyCustomPrices == 'undefined') {
                        return;
                    }

                    clearInterval(interval);
                    resolve();
                },
                50
            );
        }
    );

    creodeShopifyCustomPrices.bindCheckoutButtons('button[name="checkout"], #checkout-button, a[href="/checkout"]');
})();
